import React from 'react';
import './Footer.css';
import {
  MailOutlined,
  WechatFilled
} from '@ant-design/icons';

const Footer: React.FC = () => {
  const footerColumns = [
    {
      title: '产品中心',
      links: [
        { title: '软件产品', url: '/products/software' },
        { title: '云服务', url: '/products/cloud' }
      ]
    },
    {
      title: '解决方案',
      links: [
        { title: '行业解决方案', url: '/solutions/industry' },
        { title: '技术解决方案', url: '/solutions/tech' },
        { title: '定制开发', url: '/solutions/custom' }
      ]
    },
    {
      title: '关于我们',
      links: [
        { title: '团队简介', url: '/about/company' },
        { title: '报告发布', url: '/about/history' },
        { title: '联系我们', url: '/about/contact' },
        { title: '加入我们', url: '/about/contact/joinus' }
      ]
    }
  ];

  const contactInfo = [
    { icon: <WechatFilled />, text: 'lyz300' },
    { icon: <MailOutlined />, text: 'i7isoft@163.com' }
  ];

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} 数海穹览(iaya.cn) 版权所有
            <span className="beian-icon">🛡️</span>
            <a
              href="https://beian.miit.gov.cn/"
              rel="noreferrer"
              target="_blank"
              className="icp-link"
            >
              蜀ICP备2026048526号-1
            </a>
            <img
              src="/images/other/51010502015910.png"
              alt="公安备案图标"
              className="beian-icon-img"
            />
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=51010502015910"
              rel="noreferrer"
              target="_blank"
              className="beian-link"
            >
              川公网安备51010502015910号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;